import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import PersonalAreaInvoicesReducer from './PersonalAreaInvoicesSlice';

export default class PersonalAreaInvoicesInitializableModule implements IInitializableModule {
  protected name: string = 'personal-area-invoices';
  public GetName(): string {
    return this.name;
  }
  public ConfigureContainer(container: IServiceContainer): void {
  }
  public StartModule(context: IEpiserverContext): void {
  }
  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'personalAreaInvoicesPage',
      reducer: PersonalAreaInvoicesReducer,
    };
  }
}
